import React, { useState, useEffect, useRef, memo } from "react";
import DynamicTable from "../../../components/Tables";
import {
  productsList,
  createProduct,
  updateProduct,
  createBatch,
  sendNotification,
  deleteProduct,
} from "../../../services/apis";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Col, Row, Spinner, Modal, Form } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faFileImage } from "@fortawesome/free-solid-svg-icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faFileImage, faTrash } from "@fortawesome/free-solid-svg-icons";
import { faLayerGroup, faEdit } from "@fortawesome/free-solid-svg-icons";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";

const Users = () => {
  const [usersData, setUsersData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showCreateCategoryModal, setShowCreateCategoryModal] = useState(false);
  const [showUpdateCategoryModal, setShowUpdateCategoryModal] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [createAgencyModal, setCreateAgencyModal] = useState(false);
  const [batchModal, setBatchModal] = useState(false);
  const [notificationModal, setNotificationModal] = useState(false);
  const [file, setFile] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [currentProductId, setcurrentProductId] = useState(null);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]); // Stores selected images
  const [uploadImgHide, setUploadImgHide] = useState(false);
  const [updateImgHide, setUpdateImgHide] = useState(false);
  const [previewUrls, setPreviewUrls] = useState([]); // Stores preview URLs
  const [deleteProducts, setDeleteProducts] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const currentCategory = location.state?.categoryname;

  const queryParams = new URLSearchParams(location.search);
  const productcategoryid = queryParams.get("productcategoryid");

  const datepickerRef = useRef();

  const handleMfgDateChange = (date, currentAction) => {
    if (date && date?.isValid) {
      if (currentAction === "create") {
        createCategory.setFieldValue("mfg", date.format("YYYY-MM-DD"));
        createCategory.setFieldValue("exp", "");
      } else if (currentAction === "update") {
        updateCategory.setFieldValue("mfg", date.format("YYYY-MM-DD"));
        updateCategory.setFieldValue("exp", "");
      }
    }
  };

  const handleExpDateChange = (date, currentAction) => {
    if (date && date?.isValid) {
      if (currentAction === "create") {
        createCategory.setFieldValue("exp", date.format("YYYY-MM-DD"));
      } else if (currentAction === "update") {
        updateCategory.setFieldValue("exp", date.format("YYYY-MM-DD"));
      }
    }
  };

  const handleExpPark = (date) => {
    if (date && date?.isValid) {
      const formattedDate = date.format("yyyy-MM-DD");
      createBatchpark.setFieldValue("ExpiryDate", formattedDate);
      console.log("Expiry Date set to:", formattedDate);
    } else {
      createBatchpark.setFieldValue("ExpiryDate", "");
      console.log("Invalid date selected");
    }
  };

  const showCalendar = () => {
    if (datepickerRef.current) {
      datepickerRef.current.openCalendar?.();
    }
  };

  const cols = [
    {
      id: "serial",
      title: "S.No",
      isSortable: false,
      render: (_, index) => index + 1,
    },
    {
      id: "productname",
      title: "Product Name",
      key: "productname",
      iskey: true,
      isSortable: true,
      render: (value) => value,
    },
    {
      id: "sku",
      title: "SKU",
      key: "sku",
      iskey: true,
      isSortable: true,
      render: (value) => value,
    },
    {
      id: "upi",
      title: "UPI",
      key: "upi",
      iskey: true,
      isSortable: true,
      render: (value) => value,
    },
    {
      id: "mfgdate",
      title: "MFG Date",
      key: "mfgdate",
      iskey: true,
      isSortable: true,
      render: (value) => {
        if (!value) return "N/A";
        return new Date(value).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
      },
    },
    {
      id: "expirydate",
      title: "Expiry Date",
      key: "expirydate",
      iskey: true,
      isSortable: true,
      render: (value) => {
        if (!value) return "N/A";
        return new Date(value).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
      },
    },
    {
      id: "batchcode",
      title: "Batch Code",
      key: "batchcode",
      iskey: true,
      isSortable: true,
      render: (value) => value || "-",
    },
    {
      id: "batchexpirydate",
      title: "Batch Expiry ",
      key: "batchexpirydate",
      iskey: true,
      isSortable: true,
      render: (value) => {
        if (!value) return "N/A";
        return new Date(value).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
      },
    },
    {
      title: "Action",
      key: "productid",
      id: "action",
      isSortable: false,
      isKey: true,
      render: (rowData) => {
        const productId = rowData.productid;
        const batchCode = rowData.batchcode;
        const expiryDate = new Date(rowData.expirydate);
        const today = new Date();

        // Check if batch creation is restricted
        const isBatchCreationRestricted = batchCode && expiryDate > today;

        // Check if attributes and notification actions are restricted
        const isAttributesNotificationRestricted = !batchCode;

        return (
          <div className="d-flex justify-content-center gap-x-1">
            <div
              style={{
                marginRight: "11px",
                cursor: "pointer",
                color: "inherit",
              }}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={"Update"}
              onClick={() => {
                updateCategory.setValues({
                  productname: rowData.productname,
                  sku: rowData.sku,
                  upi: rowData.upi,
                  exp: rowData.expirydate,
                  mfg: rowData.mfgdate,
                  ProductImages: rowData.productimages,
                });
                setShowUpdateCategoryModal(true);
                setcurrentProductId(rowData.productid);
                if (
                  rowData?.productimages &&
                  Array.isArray(rowData.productimages)
                ) {
                  // Check if the first element is null or if the array is [null]
                  if (rowData.productimages[0] === null) {
                    setImagePreviews([]); // Set an empty array if the first element is null
                  } else {
                    setImagePreviews(rowData.productimages); // Otherwise, use the existing array
                  }
                } else {
                  setImagePreviews([]); // If no images are found, set an empty array
                }
                const xx = rowData.productimages;
                console.log("xxx-->", xx, xx.length > 0, rowData);
              }}
            >
              <FontAwesomeIcon icon={faEdit} />
            </div>

            <div
              style={{
                marginRight: "11px",
                cursor: isBatchCreationRestricted ? "not-allowed" : "pointer",
                color: isBatchCreationRestricted ? "gray" : "inherit",
              }}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={
                isBatchCreationRestricted
                  ? "Batch already created."
                  : "Create Batch"
              }
              onClick={() => {
                if (!isBatchCreationRestricted) {
                  setSelectedProductId(productId);
                  createBatchpark.setFieldValue("ProductId", productId);
                  setBatchModal(true);
                  console.log(productId);
                }
              }}
            >
              <FontAwesomeIcon icon={faLayerGroup} />
            </div>

            <div
              style={{
                marginRight: "11px",
                cursor: isAttributesNotificationRestricted
                  ? "not-allowed"
                  : "pointer",
                color: isAttributesNotificationRestricted ? "gray" : "inherit",
              }}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={
                isAttributesNotificationRestricted
                  ? "Create a batch first."
                  : "Add Attributes"
              }
              onClick={() => {
                if (!isAttributesNotificationRestricted) {
                  navigate(`/admin/ProductAttributes`, {
                    state: {
                      productname: rowData.productname,
                      categoryname: rowData.categoryname,
                      productimages: rowData.productimages[0],
                      productId: productId,
                    },
                  });
                }
              }}
            >
              <FontAwesomeIcon icon={faPlus} />
            </div>

            {/* <div
              style={{
                marginRight: "11px",
                cursor: isAttributesNotificationRestricted
                  ? "not-allowed"
                  : "pointer",
                color: isAttributesNotificationRestricted ? "gray" : "inherit",
              }}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={
                isAttributesNotificationRestricted
                  ? "Create a batch first."
                  : "Send Notification"
              }
              onClick={() => {
                if (!isAttributesNotificationRestricted) {
                  setSelectedProductId(productId);
                  setNotificationModal(true);
                }
              }}
            >
              <FontAwesomeIcon icon={faBell} />
            </div> */}
            <div
              style={{ marginRight: "11px", cursor: "pointer" }}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Delete"
              className="text-danger"
              onClick={() => handleDeleteClick(productId)}
            >
              <FontAwesomeIcon icon={faTrash} />
            </div>
          </div>
        );
      },
    },
  ];

  const handleImageChange = (event) => {
    if (!event.target.files) return;

    const newFiles = Array.from(event.target.files);
    const newFileURLs = newFiles.map((file) => URL.createObjectURL(file));

    let updatedFiles = [...selectedFiles, ...newFiles];
    let updatedPreviewFiles = [...previewUrls, ...newFileURLs];

    if (updatedFiles.length >= 5) {
      console.log("55555 ---------------------");
      setUploadImgHide(true);
      updatedFiles = updatedFiles.slice(0, 5);
      updatedPreviewFiles = updatedPreviewFiles.slice(0, 5);
    }

    setSelectedFiles(updatedFiles);
    setPreviewUrls(updatedPreviewFiles);

    createCategory.setFieldValue("ProductImages", updatedFiles);
  };

  const removeUploadImage = (index) => {
    const updatedFiles = selectedFiles.filter((_, i) => i !== index);
    const updatedPreviews = previewUrls.filter((_, i) => i !== index);

    // if (updatedFiles.length) {

    // }

    if (updatedFiles.length < 5) {
      console.log("len***>", updatedFiles.length);
      setUploadImgHide(false);
    }

    setSelectedFiles(updatedFiles);
    setPreviewUrls(updatedPreviews);

    createCategory.setFieldValue("ProductImages", updatedFiles);
  };

  const handleImageUpdate = (event) => {
    // Get all newly selected files (multiple files can be selected)
    const files = Array.from(event.target.files);

    // Get existing image URLs (from API)
    const existingImages = updateCategory.values.ProductImages.filter(
      (img) => typeof img === "string" // Only keep the image URLs as strings
    );

    // Append new files (if any) to the existing images list
    let updatedImages = [
      ...existingImages, // Keep existing image URLs
      ...files, // Add newly selected files (images)
    ];

    if (updatedImages.length >= 5) {
      console.log("Image limit reached. Only 5 images are allowed.");
      setUpdateImgHide(true);
      updatedImages = updatedImages.slice(0, 5);
    }

    // Update the form value with the combined images (existing + new files)
    updateCategory.setFieldValue("ProductImages", updatedImages);

    // Generate previews for both existing images and newly selected files
    const previewImages = updatedImages.map(
      (image) =>
        typeof image === "string" ? image : URL.createObjectURL(image) // Preview for URLs and files
    );

    // Update the state to display the image previews
    setImagePreviews(previewImages);

    // Log the updated images for debugging purposes
    console.log("Updated Images:", updatedImages);
  };

  const removeImage = (index) => {
    const newImages = [...updateCategory.values.ProductImages];
    newImages.splice(index, 1);
    updateCategory.setFieldValue("ProductImages", newImages);

    const newPreviews = [...imagePreviews];
    newPreviews.splice(index, 1);
    setImagePreviews(newPreviews);

    if (newImages.length < 5) {
      setUpdateImgHide(false); // Ensure upload button reappears
    }
  };

  const createCategory = useFormik({
    initialValues: {
      productname: "",
      sku: "",
      upi: "",
      exp: "",
      mfg: "",
      ProductImages: [],
      // categoryId: productcategoryid || "",
    },
    validationSchema: Yup.object().shape({
      productname: Yup.string().required("Product name is required"),
      sku: Yup.string().required("SKU is required"),
      upi: Yup.string().required("UPI is required"),
      exp: Yup.string().required("Expiry date is required"),
      mfg: Yup.string().required("Manufacturing date is required"),
      ProductImages: Yup.array()
        .min(1, "At least one product image is required")
        .test("fileType", "Unsupported file format", (images) => {
          return images?.every(
            (image) =>
              typeof image === "string" || // Allow existing URLs
              ["image/jpeg", "image/png", "image/gif", "image/webp"].includes(
                image.type
              )
          );
        }),
    }),
    onSubmit: async (values) => {
      console.log("correct entry***");

      try {
        setIsButtonClicked(true);
        console.log(values);

        const form = new FormData();
        form.append("productname", values.productname);
        form.append("exp", values.exp);
        form.append("mfg", values.mfg);
        form.append("upi", values.upi);
        form.append("sku", values.sku);
        // form.append("ProductImages", values.ProductImages);
        form.append("categoryId", productcategoryid);

        values.ProductImages.forEach((image) => {
          if (typeof image === "string" && image.startsWith("http")) {
            form.append("ProductImages", image); // Append URLs
          }
        });

        // Then handle files (if any)
        values.ProductImages.forEach((image) => {
          if (image instanceof File) {
            form.append("ProductImages", image); // Append each file under the same key
          }
        });

        console.log("formm++", form);

        const response = await createProduct(form);

        console.log("response==>>>", response);

        if (response && response.statuscode === 1) {
          toast.dismiss();
          toast.success(response.message);
          createCategory.resetForm();
          createCategory.setFieldValue("ProductImages", []); // Reset the ProductImages field to null
          setFile(null);
          setSelectedFiles([]);
          setPreviewUrls([]);
          fetchUsers(productcategoryid);
          setShowCreateCategoryModal(false);
        } else {
          console.log("ennterr=>");

          toast.dismiss();
          toast.error(response.message);
        }
      } catch (error) {
        console.error("Error:", error);
        toast.dismiss();
        toast.error(
          error ||
            error.response.data.message ||
            "There was an error creating the product."
        );
      } finally {
        setIsButtonClicked(false);
      }
    },
  });

  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const updateCategory = useFormik({
    initialValues: {
      productname: "",
      sku: "",
      upi: "",
      exp: "",
      mfg: "",
      ProductImages: [],
    },
    validationSchema: Yup.object().shape({
      productname: Yup.string().required("Product name is required"),
      sku: Yup.string().required("SKU is required"),
      upi: Yup.string().required("UPI is required"),
      exp: Yup.string().required("Expiry date is required"),
      mfg: Yup.string().required("Manufacturing date is required"),
      ProductImages: Yup.array()
        .min(1, "At least one product image is required")
        .test("fileType", "Unsupported file format", (images) => {
          return images?.every(
            (image) =>
              typeof image === "string" || // Check if it's a string (in case of URL string)
              ["image/jpeg", "image/png", "image/gif", "image/webp"].includes(
                image.type
              )
          );
        }),
    }),
    onSubmit: async (values) => {
      // debugger;
      try {
        setIsButtonClicked(true);
        console.log(values);

        const form = new FormData();
        form.append("productname", values.productname);
        form.append("sku", values.sku);
        form.append("upi", values.upi);
        form.append("exp", values.exp);
        form.append("mfg", values.mfg);
        form.append("categoryId", productcategoryid);

        // First handle URLs (if any)
        values.ProductImages.forEach((image) => {
          if (typeof image === "string" && image.startsWith("http")) {
            form.append("ProductImages", image); // Append URLs
          }
        });

        // Then handle files (if any)
        values.ProductImages.forEach((image) => {
          if (image instanceof File) {
            form.append("ProductImages", image); // Append each file under the same key
          }
        });

        const response = await updateProduct(form, currentProductId);

        console.log("res", response);

        if (response && response.statuscode === 1) {
          toast.dismiss();
          toast.success(response.message);
          fetchUsers(productcategoryid);
          setShowUpdateCategoryModal(false);
        } else {
          toast.dismiss();
          toast.error(response.message);
        }
      } catch (error) {
        console.error("Error:", error);
        toast.dismiss();
        toast.error("There was an error updating the product.");
      } finally {
        setIsButtonClicked(false);
      }
    },
  });

  console.log("u-pdateCategory===>", updateCategory);

  /////////////////

  const createBatchpark = useFormik({
    initialValues: {
      Batchcode: "",
      ProductId: "",
      ExpiryDate: "",
    },
    validationSchema: Yup.object().shape({
      Batchcode: Yup.string().required("Batchcode is required"),
      ExpiryDate: Yup.string().required("Expiry date is required"),
    }),

    onSubmit: async (values) => {
      console.log("Submitting values:", values);
      setIsButtonClicked(true);
      try {
        const response = await createBatch(values);
        console.log("API response:", response);

        // toast.dismiss();
        // toast.success("Batch created successfully!");

        if (response && response.statuscode === 1) {
          toast.dismiss();
          toast.success(response.message);
          setBatchModal(false);
          fetchUsers(productcategoryid);
          createBatchpark.resetForm();
        } else {
          toast.dismiss();
          toast.warning(response.message);
        }
      } catch (error) {
        console.error("API call failed:", error);
        const errorMessage =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        toast.dismiss();
        toast.error(errorMessage);
      } finally {
        setIsButtonClicked(false);
      }
    },
  });

  const sendMessage = useFormik({
    initialValues: {
      topic: "",
      title: "",
      text: "",
    },
    validationSchema: Yup.object().shape({
      text: Yup.string().required("Message is required"),
    }),

    onSubmit: async (values) => {
      console.log("Submitting values:", values);
      setIsButtonClicked(true);
      try {
        const response = await sendNotification(values);
        console.log("API response:", response);
      } catch (error) {
        console.error("API call failed:", error);
      } finally {
        setIsButtonClicked(false);
      }
    },
  });

  const fetchUsers = async (productcategoryid) => {
    try {
      setIsLoading(true);
      const response = await productsList(productcategoryid);
      if (response.statuscode === 1) {
        setUsersData(response.data);
      } else {
        setError("No products found for the selected category.");
      }
    } catch (error) {
      setError("Failed to fetch products. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteClick = (productId) => {
    setSelectedProductId(productId);
    setDeleteProducts(true); // Show modal
  };

  const handleDelete = async () => {
    console.log("handleDelete===============");
    if (!selectedProductId) return;
    setIsLoading(true);

    try {
      const result = await deleteProduct(selectedProductId);

      if (result?.statuscode === 1) {
        setUsersData((prevProducts) =>
          prevProducts.filter(
            (product) => product.productid !== selectedProductId
          )
        );
        toast.dismiss();
        toast.success(result.message || "Product deleted successfully.");
        setDeleteProducts(false);
      } else {
        toast.dismiss();
        toast.error(result?.message || "Failed to delete product.");
      }
    } catch (error) {
      console.error("Error deleting product:", error);
      toast.dismiss();
      toast.error("An error occurred while deleting the product.");
    } finally {
      setIsLoading(false);
      setSelectedProductId(null);
    }
  };

  useEffect(() => {
    fetchUsers(productcategoryid);
  }, [productcategoryid]);

  return (
    <div className="p-4">
      <ToastContainer />
      <div
        className="p-4 rounded d-flex justify-content-between w-100 align-items-center shadow"
        style={{ backgroundColor: "#F7F7F8" }}
      >
        <h3 style={{ color: "#262B40", fontWeight: "bold" }} className="mt-2">
          {currentCategory}
        </h3>
        <Row>
          <Col md={12} className="d-flex justify-content-between">
            <Button
              variant="primary"
              className="text-white bg-gradient"
              onClick={() => setShowCreateCategoryModal(true)}
            >
              Add New Product
            </Button>
          </Col>
        </Row>
      </div>

      <div className="mt-4 p-3 px-4 rounded-xl shadow-sm mx-3 bg-white">
        <div className="d-flex align-items-center mb-3">
          <h5
            style={{
              color: "#262B40",
              fontWeight: "bold",
              fontSize: 25,
              paddingTop: 8,
            }}
          >
            Product List
          </h5>
        </div>
        {/* {error && <div className="error-message">{error}</div>} */}
        <DynamicTable
          cols={cols}
          response={usersData}
          isPaginate={false}
          numberOfData={5}
          headerClass="table-header"
          rowHover={true}
          fixedHeight={false}
          isBgTransparent={false}
          hideHeader={false}
          isloading={isLoading}
          isFieldSortable={true}
        />
        <Modal
          show={showCreateCategoryModal}
          onHide={() => {
            createCategory.resetForm(); // Clear the form fields
            createCategory.setFieldValue("ProductImages", []); // Reset the ProductImages field to null
            setFile(null);
            setSelectedFiles([]);
            setPreviewUrls([]);
            setUploadImgHide(false);
            console.log(
              "modal is close, image reset:",
              createCategory.values.ProductImages
            );
            setShowCreateCategoryModal(false); // Close the modal
          }}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Add New Product</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                const mfgDate = moment(
                  createCategory.values.mfg,
                  "DD-MM-YYYY",
                  true
                );
                const expDate = moment(
                  createCategory.values.exp,
                  "DD-MM-YYYY",
                  true
                );
                if (mfgDate.isSameOrAfter(expDate)) {
                  toast.error(
                    "Expiry date must be greater than the Manufacturing date"
                  );
                  return; // Prevent form submission
                }
                createCategory.handleSubmit();
              }}
            >
              <div className="col-md-12 mb-3">
                <Form.Group>
                  <Form.Label>Upload Image</Form.Label>
                  <div className="d-flex align-items-start flex-nowrap overflow-auto">
                    {!uploadImgHide && (
                      <div
                        className={`custom-upload d-flex align-items-center justify-content-center m-2 ${
                          createCategory.touched.ProductImages &&
                          createCategory.errors.ProductImages
                            ? "border-danger"
                            : ""
                        }`}
                        onClick={() =>
                          document.getElementById("fileInput").click()
                        }
                        style={{
                          width: "100px",
                          height: "100px",
                          border: "2px dashed #ddd",
                          borderRadius: "5px",
                          cursor: "pointer",
                          position: "relative",
                          backgroundColor: "#f8f9fa",
                        }}
                      >
                        <span
                          style={{
                            color: "#6c757d",
                            textAlign: "center",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faFileImage}
                            style={{ fontSize: "28px" }}
                          />
                        </span>
                      </div>
                    )}
                    <input
                      type="file"
                      id="fileInput"
                      accept="image/*"
                      multiple
                      style={{ display: "none" }}
                      onChange={handleImageChange}
                      onBlur={() =>
                        createCategory.setFieldTouched("ProductImages", true)
                      }
                    />
                    {previewUrls?.length > 0 &&
                      previewUrls?.map((image, index) => (
                        <div key={index} className="position-relative m-2">
                          <img
                            src={image}
                            alt="Preview"
                            style={{
                              width: "100px", // Keep the width to 100px
                              height: "100px", // Keep the height to 100px
                              objectFit: "cover", // Ensure the image doesn't stretch
                              borderRadius: "5px",
                              border: "1px solid #ddd",
                            }}
                          />
                          <FontAwesomeIcon
                            icon={faTrash}
                            onClick={() => removeUploadImage(index)}
                            className="position-absolute top-0 end-0 bg-white text-danger p-1 rounded"
                            style={{
                              cursor: "pointer",
                              width: 19,
                              height: 19,
                            }}
                          />
                        </div>
                      ))}
                  </div>

                  {createCategory.touched.ProductImages &&
                    createCategory.errors.ProductImages && (
                      <Form.Control.Feedback
                        type="invalid"
                        style={{ display: "block" }}
                      >
                        {createCategory.errors.ProductImages}
                      </Form.Control.Feedback>
                    )}
                </Form.Group>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Product Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Product Name"
                      name="productname"
                      value={createCategory.values.productname}
                      onChange={createCategory.handleChange}
                      onBlur={createCategory.handleBlur}
                      maxLength={50}
                      isInvalid={
                        createCategory.touched.productname &&
                        createCategory.errors.productname
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {createCategory.errors.productname}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>SKU</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Product SKU"
                      name="sku"
                      value={createCategory.values.sku}
                      onChange={createCategory.handleChange}
                      onBlur={createCategory.handleBlur}
                      maxLength={50}
                      isInvalid={
                        createCategory.touched.sku && createCategory.errors.sku
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {createCategory.errors.sku}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <Form.Group className="mb-3">
                    <Form.Label>UPI</Form.Label>
                    <Form.Control
                      type="text"
                      name="upi"
                      placeholder="Enter Product UPI"
                      value={createCategory.values.upi}
                      onChange={(e) => {
                        if (e.target.value.length <= 20) {
                          createCategory.setFieldValue("upi", e.target.value);
                        }
                      }}
                      onBlur={createCategory.handleBlur}
                      isInvalid={
                        createCategory.touched.upi && createCategory.errors.upi
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {createCategory.errors.upi}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>MFD Date</Form.Label>
                    <Datetime
                      inputProps={{
                        placeholder: "dd-mm-yyyy",
                        name: "mfg",
                        className: `form-control ${
                          createCategory.touched.mfg &&
                          createCategory.errors.mfg
                            ? "is-invalid"
                            : ""
                        }`,
                      }}
                      value={
                        createCategory.values.mfg
                          ? moment(createCategory.values.mfg).format(
                              "DD-MM-YYYY"
                            )
                          : ""
                      }
                      onChange={(date) => handleMfgDateChange(date, "create")}
                      onBlur={() => createCategory.setFieldTouched("mfg", true)}
                      dateFormat="DD-MM-YYYY"
                      closeOnSelect={true}
                      timeFormat={false}
                      ref={datepickerRef}
                      className="w-100"
                    />
                    <Form.Control.Feedback
                      type="invalid"
                      style={{ display: "block" }}
                    >
                      {createCategory.touched.mfg && createCategory.errors.mfg}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>EXP Date</Form.Label>
                    <Datetime
                      inputProps={{
                        placeholder: "dd-mm-yyyy",
                        name: "exp",
                        className: `form-control ${
                          createCategory.touched.exp &&
                          createCategory.errors.exp
                            ? "is-invalid"
                            : ""
                        }`,
                      }}
                      value={
                        createCategory.values.exp
                          ? moment(createCategory.values.exp).format(
                              "DD-MM-YYYY"
                            )
                          : ""
                      }
                      onChange={(date) => handleExpDateChange(date, "create")}
                      dateFormat="DD-MM-YYYY"
                      closeOnSelect={true}
                      timeFormat={false}
                      ref={datepickerRef}
                      className="w-100"
                      isValidDate={(currentDate) => {
                        const mfdDate = moment(createCategory.values.mfg); // Add 1 day to MFD Date
                        return currentDate.isAfter(mfdDate, "day"); // Ensure EXP Date is at least one day after MFD Date
                      }}
                    />
                    {createCategory.touched.exp &&
                      createCategory.errors.exp && (
                        <Form.Control.Feedback
                          type="invalid"
                          style={{ display: "block" }}
                        >
                          {createCategory.errors.exp}
                        </Form.Control.Feedback>
                      )}
                  </Form.Group>
                </div>
              </div>

              <Modal.Footer>
                <Button
                  type="submit"
                  variant="primary"
                  className="text-white bg-gradient"
                  disabled={isButtonClicked}
                >
                  {isButtonClicked ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    "Submit"
                  )}
                </Button>
              </Modal.Footer>
            </Form>
          </Modal.Body>
        </Modal>

        <Modal
          show={showUpdateCategoryModal}
          onHide={() => {
            //updateCategory.resetForm(); // Clear the form fields
            updateCategory.setFieldValue("ProductImages", ""); // Reset the ProductImages field to null
            setShowUpdateCategoryModal(false); // Close the modal
            setUpdateImgHide(false);
          }}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Product</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                updateCategory.handleSubmit();
              }}
            >
              <div className="col-md-12 mb-3">
                <Form.Group>
                  <Form.Label>Upload Image</Form.Label>
                  <div className="d-flex align-items-start flex-nowrap overflow-auto">
                    {/* <div className="d-flex flex-wrap mb-3"> */}
                    {!updateImgHide && (
                      <div
                        className={`custom-upload d-flex align-items-center justify-content-center m-2 ${
                          createCategory.touched.ProductImages &&
                          createCategory.errors.ProductImages
                            ? "border-danger"
                            : ""
                        }`}
                        onClick={() =>
                          document.getElementById("fileInput").click()
                        }
                        style={{
                          width: "100px",
                          height: "100px",
                          border: "2px dashed #ddd",
                          borderRadius: "5px",
                          cursor: "pointer",
                          position: "relative",
                          backgroundColor: "#f8f9fa",
                        }}
                      >
                        {/* {file ? (
                          <img
                            src={file}
                            alt="Uploaded Preview"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "5px",
                            }}
                          />
                        ) : ( */}
                        <span style={{ color: "#6c757d", textAlign: "center" }}>
                          <FontAwesomeIcon
                            icon={faFileImage}
                            style={{ fontSize: "28px" }}
                          />
                          {/* <br />
                          Upload Image */}
                        </span>
                        {/* )} */}
                        <input
                          type="file"
                          id="fileInput"
                          accept="image/*"
                          multiple
                          style={{ display: "none" }}
                          onChange={handleImageUpdate}
                          onBlur={() =>
                            updateCategory.setFieldTouched(
                              "ProductImages",
                              true
                            )
                          }
                        />
                      </div>
                    )}
                    {imagePreviews.length > 0 &&
                      imagePreviews?.map((image, index) => (
                        <div key={index} className="position-relative m-2">
                          <img
                            src={image}
                            alt="Preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "5px",
                              border: "1px solid #ddd",
                            }}
                          />
                          <FontAwesomeIcon
                            icon={faTrash}
                            onClick={() => removeImage(index)}
                            className="position-absolute top-6 end-0 bg-white text-danger p-1 rounded"
                            style={{
                              cursor: "pointer",
                              width: 19,
                              height: 19,
                            }}
                          />
                        </div>
                      ))}
                    {/* </div> */}
                  </div>
                  {updateCategory.touched.ProductImages &&
                    updateCategory.errors.ProductImages && (
                      <Form.Control.Feedback
                        type="invalid"
                        style={{ display: "block" }}
                      >
                        {updateCategory.errors.ProductImages}
                      </Form.Control.Feedback>
                    )}
                </Form.Group>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Product Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="productname"
                      value={updateCategory.values.productname}
                      onChange={updateCategory.handleChange}
                      onBlur={updateCategory.handleBlur}
                      maxLength={30}
                      className={
                        updateCategory.touched.productname &&
                        updateCategory.errors.productname
                          ? "is-invalid"
                          : ""
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {updateCategory.errors.productname}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>SKU</Form.Label>
                    <Form.Control
                      type="text"
                      name="sku"
                      value={updateCategory.values.sku}
                      onChange={updateCategory.handleChange}
                      onBlur={updateCategory.handleBlur}
                      maxLength={50}
                      className={
                        updateCategory.touched.sku && updateCategory.errors.sku
                          ? "is-invalid"
                          : ""
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {updateCategory.errors.sku}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <Form.Group className="mb-3">
                    <Form.Label>UPI</Form.Label>
                    <Form.Control
                      type="text"
                      name="upi"
                      value={updateCategory.values.upi}
                      onChange={updateCategory.handleChange}
                      onBlur={updateCategory.handleBlur}
                      maxLength={20}
                      className={
                        updateCategory.touched.upi && updateCategory.errors.upi
                          ? "is-invalid"
                          : ""
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {updateCategory.errors.upi}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>MFD Date</Form.Label>
                    <Datetime
                      inputProps={{
                        name: "mfg",
                        className: `form-control ${
                          updateCategory.touched.mfg &&
                          updateCategory.errors.mfg
                            ? "is-invalid"
                            : ""
                        }`,
                        style: { borderRight: "0.0625rem solid #d1d7e0" },
                      }}
                      value={moment(updateCategory.values.mfg).format(
                        "DD-MM-YYYY"
                      )}
                      onChange={(date) => handleMfgDateChange(date, "update")}
                      dateFormat="DD-MM-YYYY"
                      closeOnSelect={true}
                      timeFormat={false}
                      ref={datepickerRef}
                      className="w-100"
                    />
                    {updateCategory.touched.mfg &&
                      updateCategory.errors.mfg && (
                        <Form.Control.Feedback
                          type="invalid"
                          style={{ display: "block" }}
                        >
                          {updateCategory.errors.mfg}
                        </Form.Control.Feedback>
                      )}
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>EXP Date</Form.Label>
                    <Datetime
                      inputProps={{
                        name: "exp",
                        className: `form-control ${
                          updateCategory.touched.exp &&
                          updateCategory.errors.exp
                            ? "is-invalid"
                            : ""
                        }`,
                        style: { borderRight: "0.0625rem solid #d1d7e0" },
                      }}
                      value={moment(updateCategory.values.exp).format(
                        "DD-MM-YYYY"
                      )}
                      onChange={(date) => handleExpDateChange(date, "update")}
                      dateFormat="DD-MM-YYYY"
                      closeOnSelect={true}
                      timeFormat={false}
                      ref={datepickerRef}
                      className="w-100"
                      // Use isValidDate to ensure EXP Date is after MFD Date
                      isValidDate={(currentDate) => {
                        const mfgDate = moment(updateCategory.values.mfg);
                        return currentDate.isAfter(mfgDate, "day"); // Ensure EXP Date is after MFD Date
                      }}
                    />
                    {updateCategory.touched.exp &&
                      updateCategory.errors.exp && (
                        <Form.Control.Feedback
                          type="invalid"
                          style={{ display: "block" }}
                        >
                          {updateCategory.errors.exp}
                        </Form.Control.Feedback>
                      )}
                  </Form.Group>
                </div>
              </div>

              <Modal.Footer>
                <Button
                  type="submit"
                  variant="primary"
                  className="text-white bg-gradient"
                  disabled={isButtonClicked}
                >
                  {isButtonClicked ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    "Update"
                  )}
                </Button>
              </Modal.Footer>
            </Form>
          </Modal.Body>
        </Modal>

        <Modal
          show={batchModal}
          onHide={() => {
            setBatchModal(false);
            createBatchpark.resetForm();
          }}
          centered
        >
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              console.log("Attempting to submit form...");
              createBatchpark.handleSubmit();
            }}
          >
            <Modal.Header closeButton>
              <Modal.Title>Create Batch</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Form.Group className="mb-3">
                <Form.Label>Batch Code</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Batch Code"
                  name="Batchcode"
                  value={createBatchpark.values.Batchcode}
                  onChange={createBatchpark.handleChange}
                  onBlur={createBatchpark.handleBlur}
                  isInvalid={
                    createBatchpark.touched.Batchcode &&
                    createBatchpark.errors.Batchcode
                  }
                  maxLength={20}
                />
                <Form.Control.Feedback type="invalid">
                  {createBatchpark.errors.Batchcode}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Expiry Date</Form.Label>
                <Datetime
                  inputProps={{
                    placeholder: "dd-mm-yyyy",
                    name: "ExpiryDate",
                    className: `form-control ${
                      createBatchpark.touched.ExpiryDate &&
                      createBatchpark.errors.ExpiryDate
                        ? "is-invalid"
                        : ""
                    }`,
                  }}
                  value={
                    createBatchpark.values.ExpiryDate
                      ? moment(createBatchpark.values.ExpiryDate).format(
                          "DD-MM-YYYY"
                        )
                      : "" // If the value is empty or invalid, set an empty string
                  }
                  onChange={handleExpPark}
                  onBlur={() =>
                    createBatchpark.setFieldTouched("ExpiryDate", true)
                  }
                  timeFormat={false}
                  dateFormat="DD-MM-YYYY"
                  closeOnSelect={true}
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={{ display: "block" }}
                >
                  {createBatchpark.touched.ExpiryDate &&
                    createBatchpark.errors.ExpiryDate}
                </Form.Control.Feedback>
              </Form.Group>
            </Modal.Body>

            <Modal.Footer>
              <Button
                type="submit"
                variant="primary"
                className="text-white"
                disabled={isButtonClicked}
              >
                {isButtonClicked ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Create Batch"
                )}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        <Modal
          show={notificationModal}
          onHide={() => setNotificationModal(false)}
          centered
        >
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              sendMessage.handleSubmit();
            }}
          >
            <Modal.Header closeButton>
              <Modal.Title>Send Notification</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="col-md-12">
                <Form.Group className="mb-3">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter message here..."
                    name="message"
                    value={createBatchpark.values.message}
                    onChange={createBatchpark.handleChange}
                    onBlur={createBatchpark.handleBlur}
                  />
                  <Form.Control.Feedback type="invalid">
                    {createBatchpark.errors.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button
                type="submit"
                variant="primary"
                disabled={isButtonClicked}
              >
                {isButtonClicked ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Send Notification"
                )}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        <Modal
          show={deleteProducts}
          onHide={() => setDeleteProducts(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Delete Product</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete this product?</Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="text-white bg-gradient"
              onClick={handleDelete} // Call without argument to confirm deletion
              disabled={isLoading}
            >
              {isLoading ? "Deleting..." : "Confirm Delete"}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default memo(Users);
